import { render } from "./ExamSelfcheckTransition.vue?vue&type=template&id=639f979e"
import script from "./ExamSelfcheckTransition.vue?vue&type=script&lang=js"
export * from "./ExamSelfcheckTransition.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__